import { sendConfirmationEmail as sendConfirmationEmailService } from '../../../services/api/customer';
import { getToken } from '../user/selectors';
import types from './types';
import { ALERT_SUCCESS, ALERT_ERROR } from './constants';

// TODO No need to nest payload data here
export const setSuccessOverlay = (successOverlay = null) => ({
    type: types.SO_SET_SUCCESS_OVERLAY,
    payload: {
        successOverlay
    }
});

// TODO Make a separate clear action
export const clearSuccessOverlay = () => ({
    type: types.SO_SET_SUCCESS_OVERLAY,
    payload: {
        successOverlay: null
    }
});

// TODO No need to nest payload data here
export const setParamEmailProvider = (emailProvider = null) => ({
    type: types.SO_SET_PARAM_MAIL_PROVIDER,
    payload: {
        emailProvider
    }
});

// TODO success != alert, change naming of types and actions
export const showSuccessAlert = (message) => ({
    type: types.SO_SET_ALERT,
    payload: {
        type: ALERT_SUCCESS,
        message
    }
});

export const showErrorAlert = (message) => ({
    type: types.SO_SET_ALERT,
    payload: {
        type: ALERT_ERROR,
        message
    }
});

export const clearAlert = () => ({
    type: types.SO_CLEAR_ALERT
});

export const showDisappearingAlert = (
    { type, message },
    duration = 3000,
) => dispatch => {
    const showAlert =
        type === ALERT_SUCCESS ? showSuccessAlert : showErrorAlert;

    dispatch(showAlert(message));
    setTimeout(() => {
        dispatch(clearAlert());
    }, duration);
};

// TODO No need to nest payload data here
export const setSendingConfirmationEmail = (sendingConfirmationEmail) => ({
    type: types.SO_SET_PARAM_SEND_CONFIRMATION_EMAIL,
    payload: {
        sendingConfirmationEmail
    }
});

export const sendConfirmationEmail = ({ successMessage, errorMessage }) => async (dispatch, getState) => {
    dispatch(clearAlert());
    dispatch(setSendingConfirmationEmail(true));
    try {
        const token = getToken(getState());
        await sendConfirmationEmailService({ token });
        dispatch(
            showDisappearingAlert({
                type: ALERT_SUCCESS,
                message: successMessage
            })
        );
    }
    catch (e) {
        dispatch(
            showDisappearingAlert({
                type: ALERT_ERROR,
                message: errorMessage
            })
        );
    }
    dispatch(setSendingConfirmationEmail(false));
};
